import React, { useEffect, useState } from "react";
import "./login.css";
import { GET_USER } from "./helpers/endpointService";
import axios from "axios";
import { useNavigate } from "react-router";
import { PENDING_TASKS } from "./helpers/routerPaths";
import { FAVORITES } from "./helpers/routerPaths";
import { PulseLoader } from "react-spinners";
import { logoutFunction } from "./components/custom/commonFunction";

const Login = () => {
  const nav = useNavigate();
  const userMail = JSON.parse(localStorage.getItem("userDataDecode"))?.email;
  const [isLoginLoader, setLoginLoader] = useState(false);

  useEffect(() => {
    if (userMail) {
      setLoginLoader(true);
      const userDetails = localStorage.getItem("userData");
      let userToken = JSON.parse(userDetails);
      let loginApiUrl = `${GET_USER}?email=${userMail}`;
      axios({
        method: "GET",
        url: loginApiUrl,
        headers: {
          Authorization: "Bearer " + userToken.id_token,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data) {
              localStorage.setItem("UserId", response?.data?.id);
              localStorage.setItem(
                "Role",
                response?.data?.roleName.toLowerCase()
              );
              if (response?.data?.roleName.toLowerCase() === "user") {
                nav(FAVORITES);
              } else {
                nav(PENDING_TASKS);
              }
            }
          }
        })
        .catch((error) => {
          setLoginLoader(false);
          // nav(PENDING_TASKS)
          logoutFunction(error?.response?.status);
          //  window.location.pathname = "/sessionexpired";
        });
    }
  }, [userMail]);
  return (
    <>
      {isLoginLoader && (
        <div className="loader">
          <div className="spinner_overlay">
            <div className="loader">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
